/**
 * valumize API for managing funds
 * Lorem ipsum ...
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AggregatedFundCashflows } from '../model/aggregated-fund-cashflows';
// @ts-ignore
import { AiSetupAcceptRequest } from '../model/ai-setup-accept-request';
// @ts-ignore
import { AiSetupJobDetail } from '../model/ai-setup-job-detail';
// @ts-ignore
import { AiSetupJobInfo } from '../model/ai-setup-job-info';
// @ts-ignore
import { AiSetupRequest } from '../model/ai-setup-request';
// @ts-ignore
import { AssetValuationsSelectionRow } from '../model/asset-valuations-selection-row';
// @ts-ignore
import { CashflowPattern } from '../model/cashflow-pattern';
// @ts-ignore
import { CashflowPatternUpdateResult } from '../model/cashflow-pattern-update-result';
// @ts-ignore
import { ComputeSensitivitiesRequest } from '../model/compute-sensitivities-request';
// @ts-ignore
import { CopyConfig } from '../model/copy-config';
// @ts-ignore
import { CreateGeneralPartnerAndAssignRequest } from '../model/create-general-partner-and-assign-request';
// @ts-ignore
import { Exception } from '../model/exception';
// @ts-ignore
import { ForecastNetCurrentAssetRequest } from '../model/forecast-net-current-asset-request';
// @ts-ignore
import { Fund } from '../model/fund';
// @ts-ignore
import { FundData } from '../model/fund-data';
// @ts-ignore
import { FundInvestment } from '../model/fund-investment';
// @ts-ignore
import { FundInvestmentProfile } from '../model/fund-investment-profile';
// @ts-ignore
import { FundMergePreview } from '../model/fund-merge-preview';
// @ts-ignore
import { FundPage } from '../model/fund-page';
// @ts-ignore
import { FundReport } from '../model/fund-report';
// @ts-ignore
import { FundReportCompact } from '../model/fund-report-compact';
// @ts-ignore
import { FundValuation } from '../model/fund-valuation';
// @ts-ignore
import { FundValuationDeferralData } from '../model/fund-valuation-deferral-data';
// @ts-ignore
import { FundValuationOverviewPage } from '../model/fund-valuation-overview-page';
// @ts-ignore
import { FundValuationScenario } from '../model/fund-valuation-scenario';
// @ts-ignore
import { FundValuationSensitivity } from '../model/fund-valuation-sensitivity';
// @ts-ignore
import { FundValuationSensitivityOverview } from '../model/fund-valuation-sensitivity-overview';
// @ts-ignore
import { FundValuationWithScenarios } from '../model/fund-valuation-with-scenarios';
// @ts-ignore
import { FundValuationWithScnsAndAggrCFs } from '../model/fund-valuation-with-scns-and-aggr-cfs';
// @ts-ignore
import { FundWeightedCashflowBreakdown } from '../model/fund-weighted-cashflow-breakdown';
// @ts-ignore
import { GeneralPartner } from '../model/general-partner';
// @ts-ignore
import { GeneralPartnerPage } from '../model/general-partner-page';
// @ts-ignore
import { GoalSeekRequest } from '../model/goal-seek-request';
// @ts-ignore
import { GpTrackRecord } from '../model/gp-track-record';
// @ts-ignore
import { PartnershipInvestment } from '../model/partnership-investment';
// @ts-ignore
import { PatchFundRequest } from '../model/patch-fund-request';
// @ts-ignore
import { PatchGeneralPartnerRequest } from '../model/patch-general-partner-request';
// @ts-ignore
import { PatternAssignment } from '../model/pattern-assignment';
// @ts-ignore
import { PreviewReturnSummaryRequest } from '../model/preview-return-summary-request';
// @ts-ignore
import { RecalculateUndrawnResult } from '../model/recalculate-undrawn-result';
// @ts-ignore
import { ReferenceNTvpi } from '../model/reference-n-tvpi';
// @ts-ignore
import { ScenarioNTvpi } from '../model/scenario-n-tvpi';
// @ts-ignore
import { TopDownValuationCalcRequest } from '../model/top-down-valuation-calc-request';
// @ts-ignore
import { TraceableText } from '../model/traceable-text';
// @ts-ignore
import { UpdateFundInvestmentDevelopmentsSinceInvestmentRequest } from '../model/update-fund-investment-developments-since-investment-request';
// @ts-ignore
import { UpdateFundInvestmentRealizationRequest } from '../model/update-fund-investment-realization-request';
// @ts-ignore
import { UpdateFundInvestmentRecentFinancialPerformanceRequest } from '../model/update-fund-investment-recent-financial-performance-request';
// @ts-ignore
import { UpdateFundInvestmentTransactionSummaryRequest } from '../model/update-fund-investment-transaction-summary-request';
// @ts-ignore
import { UpdateFundReportRequest } from '../model/update-fund-report-request';
// @ts-ignore
import { UpdateFundRequest } from '../model/update-fund-request';
// @ts-ignore
import { UpdateFundValuationDescriptionRequest } from '../model/update-fund-valuation-description-request';
// @ts-ignore
import { UpdateFundValuationManagementFeeScaleRequest } from '../model/update-fund-valuation-management-fee-scale-request';
// @ts-ignore
import { UpdateFundValuationRequest } from '../model/update-fund-valuation-request';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class FundApiService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Accepts a single AI-generated result
     * Records the user\&#39;s acceptance of an AI-generated value (optionally with edits) and writes it to the underlying Asset. Source on the Asset\&#39;s Traceable field becomes \&#39;user\&#39;; refDocument records the originating job for audit. Disclaimer version must be provided.
     * @param resultId 
     * @param aiSetupAcceptRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public acceptAiSetupResult(resultId: number, aiSetupAcceptRequest: AiSetupAcceptRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public acceptAiSetupResult(resultId: number, aiSetupAcceptRequest: AiSetupAcceptRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public acceptAiSetupResult(resultId: number, aiSetupAcceptRequest: AiSetupAcceptRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public acceptAiSetupResult(resultId: number, aiSetupAcceptRequest: AiSetupAcceptRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (resultId === null || resultId === undefined) {
            throw new Error('Required parameter resultId was null or undefined when calling acceptAiSetupResult.');
        }
        if (aiSetupAcceptRequest === null || aiSetupAcceptRequest === undefined) {
            throw new Error('Required parameter aiSetupAcceptRequest was null or undefined when calling acceptAiSetupResult.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ai-setup-results/${this.configuration.encodeParam({name: "resultId", value: resultId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/accept`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: aiSetupAcceptRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Apply a template group to an existing fund valuation
     * Replaces all pattern assignments on the fund valuation with deep copies from the specified template.
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param templateId The id of the pattern template to apply
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applyTemplateGroup(fundId: number, fundReportId: number, fundValuationId: number, templateId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScnsAndAggrCFs>;
    public applyTemplateGroup(fundId: number, fundReportId: number, fundValuationId: number, templateId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScnsAndAggrCFs>>;
    public applyTemplateGroup(fundId: number, fundReportId: number, fundValuationId: number, templateId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScnsAndAggrCFs>>;
    public applyTemplateGroup(fundId: number, fundReportId: number, fundValuationId: number, templateId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling applyTemplateGroup.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling applyTemplateGroup.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling applyTemplateGroup.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling applyTemplateGroup.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (templateId !== undefined && templateId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>templateId, 'templateId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/apply-template-group`;
        return this.httpClient.request<FundValuationWithScnsAndAggrCFs>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applies the unfunded-parameters setting and recalculates the undrawn valuation
     * Reads the user\&#39;s unfunded-parameters setting, sets the percentage to be drawn (from the fund\&#39;s lifecycle-period draw rate) and the per-scenario undrawn multiples (from the period × scenario × GP-quality matrix), then recalculates the undrawn valuation. The result is transient (not persisted).
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationWithScenarios 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applyUnfundedParameters(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public applyUnfundedParameters(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public applyUnfundedParameters(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public applyUnfundedParameters(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling applyUnfundedParameters.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling applyUnfundedParameters.');
        }
        if (fundValuationWithScenarios === null || fundValuationWithScenarios === undefined) {
            throw new Error('Required parameter fundValuationWithScenarios was null or undefined when calling applyUnfundedParameters.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/applyUnfundedParameters`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationWithScenarios,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assign an existing general partner to a fund
     * Links an existing general partner to the specified fund.
     * @param partnerId ID of the general partner to assign.
     * @param fundId ID of the fund to link to.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assignGeneralPartnerToFund(partnerId: number, fundId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Fund>;
    public assignGeneralPartnerToFund(partnerId: number, fundId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Fund>>;
    public assignGeneralPartnerToFund(partnerId: number, fundId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Fund>>;
    public assignGeneralPartnerToFund(partnerId: number, fundId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling assignGeneralPartnerToFund.');
        }
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling assignGeneralPartnerToFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/${this.configuration.encodeParam({name: "partnerId", value: partnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<Fund>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assign cashflow patterns for all scenarios (Low, Base &amp; High)
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param patternAssignment For each scenario (LOW, BASE, HIGH), the map of PatternType codes to the selected CashflowPattern IDs.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assignPatterns(fundId: number, fundReportId: number, fundValuationId: number, patternAssignment: PatternAssignment, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScnsAndAggrCFs>;
    public assignPatterns(fundId: number, fundReportId: number, fundValuationId: number, patternAssignment: PatternAssignment, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScnsAndAggrCFs>>;
    public assignPatterns(fundId: number, fundReportId: number, fundValuationId: number, patternAssignment: PatternAssignment, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScnsAndAggrCFs>>;
    public assignPatterns(fundId: number, fundReportId: number, fundValuationId: number, patternAssignment: PatternAssignment, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling assignPatterns.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling assignPatterns.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling assignPatterns.');
        }
        if (patternAssignment === null || patternAssignment === undefined) {
            throw new Error('Required parameter patternAssignment was null or undefined when calling assignPatterns.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/patterns`;
        return this.httpClient.request<FundValuationWithScnsAndAggrCFs>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patternAssignment,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Auto-match asset merge targets by name
     * Automatically sets mergeTargetId on source assets by matching their name against target fund assets (case-insensitive). Falls back to searching all assets in the target dataset. Returns the updated merge preview with matchCount per asset.
     * @param fundId The id of the source fund
     * @param dataset Specifies a filter for the selected (source) dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param targetDataset The dataset to search for merge-target candidates (funds and fallback assets). Optional. If nothing is specified, the master dataset is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autoMatchAssets(fundId: number, dataset?: string, targetDataset?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundMergePreview>;
    public autoMatchAssets(fundId: number, dataset?: string, targetDataset?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundMergePreview>>;
    public autoMatchAssets(fundId: number, dataset?: string, targetDataset?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundMergePreview>>;
    public autoMatchAssets(fundId: number, dataset?: string, targetDataset?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling autoMatchAssets.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (dataset !== undefined && dataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataset, 'dataset');
        }
        if (targetDataset !== undefined && targetDataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>targetDataset, 'targetDataset');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/auto-match-assets`;
        return this.httpClient.request<FundMergePreview>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calculates the cashflows for the scenario, aggregated by date.
     * Calculates and returns the cashflows for the selected fund valuation scenario, aggregated by date. Each aggregated cashflow item also contains the original cashflows.
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param scenarioId The id of the fund valuation\&#39;s scenario
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AggregatedFundCashflows>;
    public calculateAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AggregatedFundCashflows>>;
    public calculateAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AggregatedFundCashflows>>;
    public calculateAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateAggregatedFundCashflows.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling calculateAggregatedFundCashflows.');
        }
        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling calculateAggregatedFundCashflows.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario/${this.configuration.encodeParam({name: "scenarioId", value: scenarioId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/aggregated_cashflows`;
        return this.httpClient.request<AggregatedFundCashflows>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calculates a fund investment
     * Calculates and returns the fund investment
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund valuation
     * @param fundInvestment 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public calculateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public calculateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public calculateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateFundInvestment.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling calculateFundInvestment.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling calculateFundInvestment.');
        }
        if (fundInvestment === null || fundInvestment === undefined) {
            throw new Error('Required parameter fundInvestment was null or undefined when calling calculateFundInvestment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/GeneralPartnerValuation`;
        return this.httpClient.request<FundInvestment>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundInvestment,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * calculates the totals of a fund report
     * Calculates the Totals of a fund report
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundReport 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateFundReport(fundId: number, fundReportId: number, fundReport: FundReport, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundReport>;
    public calculateFundReport(fundId: number, fundReportId: number, fundReport: FundReport, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundReport>>;
    public calculateFundReport(fundId: number, fundReportId: number, fundReport: FundReport, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundReport>>;
    public calculateFundReport(fundId: number, fundReportId: number, fundReport: FundReport, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling calculateFundReport.');
        }
        if (fundReport === null || fundReport === undefined) {
            throw new Error('Required parameter fundReport was null or undefined when calling calculateFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc`;
        return this.httpClient.request<FundReport>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundReport,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calculates the values for the return summary
     * Calculates the values for the the return summary with a given fund valuation and its scenarios
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateFundReturnSummary(fundId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public calculateFundReturnSummary(fundId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public calculateFundReturnSummary(fundId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public calculateFundReturnSummary(fundId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateFundReturnSummary.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling calculateFundReturnSummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/returnSummary`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calculates the values for the top down valuation
     * Calculates the values for the the top down valuation with a given fund valuation and its scenarios
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param topDownValuationCalcRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateTopDownValuation(fundId: number, fundValuationId: number, topDownValuationCalcRequest: TopDownValuationCalcRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public calculateTopDownValuation(fundId: number, fundValuationId: number, topDownValuationCalcRequest: TopDownValuationCalcRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public calculateTopDownValuation(fundId: number, fundValuationId: number, topDownValuationCalcRequest: TopDownValuationCalcRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public calculateTopDownValuation(fundId: number, fundValuationId: number, topDownValuationCalcRequest: TopDownValuationCalcRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateTopDownValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling calculateTopDownValuation.');
        }
        if (topDownValuationCalcRequest === null || topDownValuationCalcRequest === undefined) {
            throw new Error('Required parameter topDownValuationCalcRequest was null or undefined when calling calculateTopDownValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/topDownValuation`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: topDownValuationCalcRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calculates the values for the undrawn valuation
     * Calculates the values for the the undrawn valuation with a given fund valuation and its scenarios
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationWithScenarios 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateUndrawnValuation(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public calculateUndrawnValuation(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public calculateUndrawnValuation(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public calculateUndrawnValuation(fundId: number, fundValuationId: number, fundValuationWithScenarios: FundValuationWithScenarios, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling calculateUndrawnValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling calculateUndrawnValuation.');
        }
        if (fundValuationWithScenarios === null || fundValuationWithScenarios === undefined) {
            throw new Error('Required parameter fundValuationWithScenarios was null or undefined when calling calculateUndrawnValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/undrawnValuation`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationWithScenarios,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Trigger sensitivity calculations for a fund valuation
     * Runs calculations for all sensitivities of the given fund valuation and returns a summary of results.
     * @param fundId 
     * @param fundValuationId 
     * @param computeSensitivitiesRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public computeSensitivitiesForFundValuation(fundId: number, fundValuationId: number, computeSensitivitiesRequest?: ComputeSensitivitiesRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationSensitivityOverview>;
    public computeSensitivitiesForFundValuation(fundId: number, fundValuationId: number, computeSensitivitiesRequest?: ComputeSensitivitiesRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationSensitivityOverview>>;
    public computeSensitivitiesForFundValuation(fundId: number, fundValuationId: number, computeSensitivitiesRequest?: ComputeSensitivitiesRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationSensitivityOverview>>;
    public computeSensitivitiesForFundValuation(fundId: number, fundValuationId: number, computeSensitivitiesRequest?: ComputeSensitivitiesRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling computeSensitivitiesForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling computeSensitivitiesForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/sensitivities:compute`;
        return this.httpClient.request<FundValuationSensitivityOverview>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: computeSensitivitiesRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start an asynchronous copy of an existing fund report and/or fund valuation
     * Kicks off an asynchronous job that copies an existing fund report and/or fund valuation (including scenarios, deferrals and asset valuations) and recalculates the copied asset valuations. Returns immediately; the user is notified via the notification bell when the job finishes. Only one copy per source report/valuation may run at a time; a second attempt while a job is active fails with 409.
     * @param copyConfig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public copyFundReportAndValuations(copyConfig: CopyConfig, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<number>;
    public copyFundReportAndValuations(copyConfig: CopyConfig, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<number>>;
    public copyFundReportAndValuations(copyConfig: CopyConfig, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<number>>;
    public copyFundReportAndValuations(copyConfig: CopyConfig, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (copyConfig === null || copyConfig === undefined) {
            throw new Error('Required parameter copyConfig was null or undefined when calling copyFundReportAndValuations.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/copy`;
        return this.httpClient.request<number>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: copyConfig,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new fund
     * Creates and returns a new fund
     * @param fund 
     * @param selectedDataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFund(fund: Fund, selectedDataset?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Fund>;
    public createFund(fund: Fund, selectedDataset?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Fund>>;
    public createFund(fund: Fund, selectedDataset?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Fund>>;
    public createFund(fund: Fund, selectedDataset?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fund === null || fund === undefined) {
            throw new Error('Required parameter fund was null or undefined when calling createFund.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (selectedDataset !== undefined && selectedDataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>selectedDataset, 'selectedDataset');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds`;
        return this.httpClient.request<Fund>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fund,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new fund report
     * Creates and returns a new fund report
     * @param fundId The id of the fund
     * @param fundReport 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFundReport(fundId: number, fundReport: FundReport, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundReport>;
    public createFundReport(fundId: number, fundReport: FundReport, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundReport>>;
    public createFundReport(fundId: number, fundReport: FundReport, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundReport>>;
    public createFundReport(fundId: number, fundReport: FundReport, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling createFundReport.');
        }
        if (fundReport === null || fundReport === undefined) {
            throw new Error('Required parameter fundReport was null or undefined when calling createFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports`;
        return this.httpClient.request<FundReport>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundReport,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new fund valuation
     * Creates and returns a new fund valuation
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuation 
     * @param templateId Optional pattern template ID to use for the new fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFundValuation(fundId: number, fundReportId: number, fundValuation: FundValuation, templateId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public createFundValuation(fundId: number, fundReportId: number, fundValuation: FundValuation, templateId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public createFundValuation(fundId: number, fundReportId: number, fundValuation: FundValuation, templateId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public createFundValuation(fundId: number, fundReportId: number, fundValuation: FundValuation, templateId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling createFundValuation.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling createFundValuation.');
        }
        if (fundValuation === null || fundValuation === undefined) {
            throw new Error('Required parameter fundValuation was null or undefined when calling createFundValuation.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (templateId !== undefined && templateId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>templateId, 'templateId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuation,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new fund valuation scenario
     * Creates and returns a new fund valuation scenario
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationScenario 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFundValuationScenario(fundId: number, fundValuationId: number, fundValuationScenario: FundValuationScenario, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationScenario>;
    public createFundValuationScenario(fundId: number, fundValuationId: number, fundValuationScenario: FundValuationScenario, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationScenario>>;
    public createFundValuationScenario(fundId: number, fundValuationId: number, fundValuationScenario: FundValuationScenario, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationScenario>>;
    public createFundValuationScenario(fundId: number, fundValuationId: number, fundValuationScenario: FundValuationScenario, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling createFundValuationScenario.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling createFundValuationScenario.');
        }
        if (fundValuationScenario === null || fundValuationScenario === undefined) {
            throw new Error('Required parameter fundValuationScenario was null or undefined when calling createFundValuationScenario.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario`;
        return this.httpClient.request<FundValuationScenario>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationScenario,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a general partner
     * Creates the general partner. Optionally links to a fund if fundId is provided.
     * @param generalPartner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createGeneralPartner(generalPartner: GeneralPartner, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GeneralPartner>;
    public createGeneralPartner(generalPartner: GeneralPartner, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GeneralPartner>>;
    public createGeneralPartner(generalPartner: GeneralPartner, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GeneralPartner>>;
    public createGeneralPartner(generalPartner: GeneralPartner, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (generalPartner === null || generalPartner === undefined) {
            throw new Error('Required parameter generalPartner was null or undefined when calling createGeneralPartner.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners`;
        return this.httpClient.request<GeneralPartner>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: generalPartner,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a general partner and assign to a fund
     * Creates a general partner and links it to the given fund in a single operation.
     * @param createGeneralPartnerAndAssignRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createGeneralPartnerAndAssignToFund(createGeneralPartnerAndAssignRequest: CreateGeneralPartnerAndAssignRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Fund>;
    public createGeneralPartnerAndAssignToFund(createGeneralPartnerAndAssignRequest: CreateGeneralPartnerAndAssignRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Fund>>;
    public createGeneralPartnerAndAssignToFund(createGeneralPartnerAndAssignRequest: CreateGeneralPartnerAndAssignRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Fund>>;
    public createGeneralPartnerAndAssignToFund(createGeneralPartnerAndAssignRequest: CreateGeneralPartnerAndAssignRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (createGeneralPartnerAndAssignRequest === null || createGeneralPartnerAndAssignRequest === undefined) {
            throw new Error('Required parameter createGeneralPartnerAndAssignRequest was null or undefined when calling createGeneralPartnerAndAssignToFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/create-and-assign`;
        return this.httpClient.request<Fund>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createGeneralPartnerAndAssignRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a fund report
     * Deletes the fund report with the specified fundReportId. **This operation requires the caller to have admin or system admin privileges.**
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFundReport(fundId: number, fundReportId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteFundReport(fundId: number, fundReportId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteFundReport(fundId: number, fundReportId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteFundReport(fundId: number, fundReportId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling deleteFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling deleteFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a fund valuation
     * Deletes the fund valuation with the specified fundValuationId along with its associated asset valuations and scenarios. **This operation requires the caller to have admin or system admin privileges.** **Note:** Deletion will fail if the fund valuation is still referenced by other entities (e.g., seller positions in deals).
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling deleteFundValuation.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling deleteFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling deleteFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the cashflows for the scenario, aggregated by date.
     * Returns the cashflows for the selected fund valuation scenario, aggregated by date. Each aggregated cashflow item also contains the original cashflows.
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param scenarioId The id of the fund valuation\&#39;s scenario
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AggregatedFundCashflows>;
    public getAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AggregatedFundCashflows>>;
    public getAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AggregatedFundCashflows>>;
    public getAggregatedFundCashflows(fundId: number, fundValuationId: number, scenarioId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getAggregatedFundCashflows.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getAggregatedFundCashflows.');
        }
        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getAggregatedFundCashflows.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario/${this.configuration.encodeParam({name: "scenarioId", value: scenarioId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/aggregated_cashflows`;
        return this.httpClient.request<AggregatedFundCashflows>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a single AI setup job with its results
     * Returns the job header plus all generated results for the viewer page.
     * @param taskInfoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAiSetupJobDetail(taskInfoId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AiSetupJobDetail>;
    public getAiSetupJobDetail(taskInfoId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AiSetupJobDetail>>;
    public getAiSetupJobDetail(taskInfoId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AiSetupJobDetail>>;
    public getAiSetupJobDetail(taskInfoId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (taskInfoId === null || taskInfoId === undefined) {
            throw new Error('Required parameter taskInfoId was null or undefined when calling getAiSetupJobDetail.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ai-setup-jobs/${this.configuration.encodeParam({name: "taskInfoId", value: taskInfoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<AiSetupJobDetail>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lists AI setup jobs for a fund
     * Returns all AI setup jobs for the fund (running and historical), sorted by start-time descending.
     * @param fundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAiSetupJobsForFund(fundId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<AiSetupJobInfo>>;
    public getAiSetupJobsForFund(fundId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<AiSetupJobInfo>>>;
    public getAiSetupJobsForFund(fundId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<AiSetupJobInfo>>>;
    public getAiSetupJobsForFund(fundId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getAiSetupJobsForFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/ai-setup-jobs`;
        return this.httpClient.request<Array<AiSetupJobInfo>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of asset valuations to select for the copy workflow
     * Gets a list of asset valuations that belong to a fund valuation to select for the copy workflow
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param copyConfig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAssetValuationsForCopyWorkflow(fundId: number, fundReportId: number, fundValuationId: number, copyConfig: CopyConfig, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<AssetValuationsSelectionRow>>;
    public getAssetValuationsForCopyWorkflow(fundId: number, fundReportId: number, fundValuationId: number, copyConfig: CopyConfig, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<AssetValuationsSelectionRow>>>;
    public getAssetValuationsForCopyWorkflow(fundId: number, fundReportId: number, fundValuationId: number, copyConfig: CopyConfig, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<AssetValuationsSelectionRow>>>;
    public getAssetValuationsForCopyWorkflow(fundId: number, fundReportId: number, fundValuationId: number, copyConfig: CopyConfig, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getAssetValuationsForCopyWorkflow.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getAssetValuationsForCopyWorkflow.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getAssetValuationsForCopyWorkflow.');
        }
        if (copyConfig === null || copyConfig === undefined) {
            throw new Error('Required parameter copyConfig was null or undefined when calling getAssetValuationsForCopyWorkflow.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/assetValuations/copy`;
        return this.httpClient.request<Array<AssetValuationsSelectionRow>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: copyConfig,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of funds valuation deferral
     * Gets all deferrals that belong to an fund valuation
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeferralsForFundValuation(fundId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationDeferralData>;
    public getDeferralsForFundValuation(fundId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationDeferralData>>;
    public getDeferralsForFundValuation(fundId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationDeferralData>>;
    public getDeferralsForFundValuation(fundId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getDeferralsForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getDeferralsForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/deferrals`;
        return this.httpClient.request<FundValuationDeferralData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the fund with the fundId
     * Gets the fund with the fundId
     * @param fundId The id of the fund
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFund(fundId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Fund>;
    public getFund(fundId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Fund>>;
    public getFund(fundId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Fund>>;
    public getFund(fundId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<Fund>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the fundData with the fundId
     * Gets the fund with the fundId
     * @param fundId The id of the fund
     * @param fundReportId Optional fundReportId
     * @param fundValuationId Optional fundValuationId; only valid if fundReportId is also provided.
     * @param dealId Optional dealID; only valid if fundValuationId is also provided.
     * @param dataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundData(fundId: number, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public getFundData(fundId: number, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public getFundData(fundId: number, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public getFundData(fundId: number, fundReportId?: number, fundValuationId?: number, dealId?: number, dataset?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundData.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundReportId !== undefined && fundReportId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundReportId, 'fundReportId');
        }
        if (fundValuationId !== undefined && fundValuationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundValuationId, 'fundValuationId');
        }
        if (dealId !== undefined && dealId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dealId, 'dealId');
        }
        if (dataset !== undefined && dataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataset, 'dataset');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/fundData`;
        return this.httpClient.request<FundData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the fund investment with the fundInvestmentId
     * Gets the fund investment of a fund report with the fundId, fundReportId and the fundInvestmentId
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public getFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public getFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public getFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundInvestment.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getFundInvestment.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling getFundInvestment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundInvestment>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Per-(fund,asset) profile for an algorithmic-DMV agent review
     * Returns the per-period trajectory of this asset inside this fund, plus the fund-level signals the agent needs to reason about likely GP action (concentration, % drawn for fundraising-likelihood inference, fund stage, GIC sector). Ownership % is included when present on the position — it\&#39;s a confidence brake on the agent\&#39;s &#x60;timing&#x60; axis (heuristics assume the GP can act on the asset). All figures are read straight from valumize-core; no derivations the algorithm doesn\&#39;t already do. 
     * @param fundId 
     * @param assetId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundInvestmentProfile(fundId: number, assetId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestmentProfile>;
    public getFundInvestmentProfile(fundId: number, assetId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestmentProfile>>;
    public getFundInvestmentProfile(fundId: number, assetId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestmentProfile>>;
    public getFundInvestmentProfile(fundId: number, assetId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundInvestmentProfile.');
        }
        if (assetId === null || assetId === undefined) {
            throw new Error('Required parameter assetId was null or undefined when calling getFundInvestmentProfile.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/assets/${this.configuration.encodeParam({name: "assetId", value: assetId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/fund-investment-profile`;
        return this.httpClient.request<FundInvestmentProfile>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get merge preview for a fund
     * Returns a read-only preview of what would happen when merging this fund into the target dataset. Shows the fund, its reports, and its assets with their merge targets and actions (MERGE or CREATE_NEW).
     * @param fundId The id of the fund
     * @param dataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundMergePreview(fundId: number, dataset?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundMergePreview>;
    public getFundMergePreview(fundId: number, dataset?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundMergePreview>>;
    public getFundMergePreview(fundId: number, dataset?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundMergePreview>>;
    public getFundMergePreview(fundId: number, dataset?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundMergePreview.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (dataset !== undefined && dataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataset, 'dataset');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/merge-preview`;
        return this.httpClient.request<FundMergePreview>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the fund report with the fundReportId
     * Gets the fund report of a fund with the fundId and fundReportId
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundReport(fundId: number, fundReportId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundReport>;
    public getFundReport(fundId: number, fundReportId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundReport>>;
    public getFundReport(fundId: number, fundReportId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundReport>>;
    public getFundReport(fundId: number, fundReportId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundReport>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the fund valuation with the fundValuationId
     * Gets the fund valuation of a fund with the fundId and fundValuationId
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuation>;
    public getFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuation>>;
    public getFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuation>>;
    public getFundValuation(fundId: number, fundReportId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundValuation.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundValuation>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the scenario with the scenarioId
     * Gets the scenario of a fund valuation with the fundId, fundValuationId and scenarioId
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param scenarioId The id of the fund valuation\&#39;s scenario
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationScenario>;
    public getFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationScenario>>;
    public getFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationScenario>>;
    public getFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getFundValuationScenario.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getFundValuationScenario.');
        }
        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getFundValuationScenario.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario/${this.configuration.encodeParam({name: "scenarioId", value: scenarioId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundValuationScenario>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the weighted cashflow breakdown for a fund valuation at a specific date.
     * @param fundValuationId 
     * @param date 
     * @param cashflowTypes 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundWeightedCashflowBreakdown(fundValuationId: number, date: string, cashflowTypes?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundWeightedCashflowBreakdown>;
    public getFundWeightedCashflowBreakdown(fundValuationId: number, date: string, cashflowTypes?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundWeightedCashflowBreakdown>>;
    public getFundWeightedCashflowBreakdown(fundValuationId: number, date: string, cashflowTypes?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundWeightedCashflowBreakdown>>;
    public getFundWeightedCashflowBreakdown(fundValuationId: number, date: string, cashflowTypes?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getFundWeightedCashflowBreakdown.');
        }
        if (date === null || date === undefined) {
            throw new Error('Required parameter date was null or undefined when calling getFundWeightedCashflowBreakdown.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>date, 'date');
        }
        if (cashflowTypes) {
            cashflowTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'cashflowTypes');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/fund-valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/weighted-cashflow-breakdown`;
        return this.httpClient.request<FundWeightedCashflowBreakdown>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of funds
     * Gets all funds
     * @param selectedDataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param isArchived Optional filter parameter. If nothing is specified, the endpoint returns both archived and unarchived funds. If set to false, returns only unarchived funds; if set to true, returns only archived funds.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFunds(selectedDataset?: string, isArchived?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<Fund>>;
    public getFunds(selectedDataset?: string, isArchived?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<Fund>>>;
    public getFunds(selectedDataset?: string, isArchived?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<Fund>>>;
    public getFunds(selectedDataset?: string, isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (selectedDataset !== undefined && selectedDataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>selectedDataset, 'selectedDataset');
        }
        if (isArchived !== undefined && isArchived !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isArchived, 'isArchived');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds`;
        return this.httpClient.request<Array<Fund>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of funds
     * Gets all funds that belong to a general partner
     * @param partnerId ID of the general partner to assign.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFundsForGeneralPartner(partnerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<Fund>>;
    public getFundsForGeneralPartner(partnerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<Fund>>>;
    public getFundsForGeneralPartner(partnerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<Fund>>>;
    public getFundsForGeneralPartner(partnerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling getFundsForGeneralPartner.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/${this.configuration.encodeParam({name: "partnerId", value: partnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/funds`;
        return this.httpClient.request<Array<Fund>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the general partner with the partnerId
     * Gets the general partner with the partnerId
     * @param partnerId The id of the general partner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGeneralPartner(partnerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GeneralPartner>;
    public getGeneralPartner(partnerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GeneralPartner>>;
    public getGeneralPartner(partnerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GeneralPartner>>;
    public getGeneralPartner(partnerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling getGeneralPartner.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/${this.configuration.encodeParam({name: "partnerId", value: partnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<GeneralPartner>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of general partners
     * Gets all general partners
     * @param isArchived Optional filter parameter. If nothing is specified, the endpoint returns both archived and unarchived general partners. If set to false, returns only unarchived general partners; if set to true, returns only archived general partners.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGeneralPartners(isArchived?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<GeneralPartner>>;
    public getGeneralPartners(isArchived?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<GeneralPartner>>>;
    public getGeneralPartners(isArchived?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<GeneralPartner>>>;
    public getGeneralPartners(isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (isArchived !== undefined && isArchived !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isArchived, 'isArchived');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners`;
        return this.httpClient.request<Array<GeneralPartner>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggregated realized-exit stats for a GP, filtered by GIC + vintage
     * For each fund owned by the GP whose vintage falls inside [vintageMin, vintageMax], looks at the latest report\&#39;s realized fund investments, joins on the underlying asset\&#39;s GIC sector, and aggregates: count of realized exits, median MoIC, median hold period (years). Used by the agent\&#39;s Step-2 GP-baseline check. 
     * @param gpId 
     * @param gicCode Optional GIC code filter. Omit to aggregate across all sectors.
     * @param vintageMin Optional inclusive lower bound on Fund.vintageYear
     * @param vintageMax Optional inclusive upper bound on Fund.vintageYear
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGpTrackRecord(gpId: number, gicCode?: string, vintageMin?: number, vintageMax?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GpTrackRecord>;
    public getGpTrackRecord(gpId: number, gicCode?: string, vintageMin?: number, vintageMax?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GpTrackRecord>>;
    public getGpTrackRecord(gpId: number, gicCode?: string, vintageMin?: number, vintageMax?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GpTrackRecord>>;
    public getGpTrackRecord(gpId: number, gicCode?: string, vintageMin?: number, vintageMax?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (gpId === null || gpId === undefined) {
            throw new Error('Required parameter gpId was null or undefined when calling getGpTrackRecord.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (gicCode !== undefined && gicCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>gicCode, 'gicCode');
        }
        if (vintageMin !== undefined && vintageMin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vintageMin, 'vintageMin');
        }
        if (vintageMax !== undefined && vintageMax !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vintageMax, 'vintageMax');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/gps/${this.configuration.encodeParam({name: "gpId", value: gpId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/track-record`;
        return this.httpClient.request<GpTrackRecord>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of fund investments
     * Gets all fund investments that belong to a fund report
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvestmentsForFundReport(fundId: number, fundReportId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundInvestment>>;
    public getInvestmentsForFundReport(fundId: number, fundReportId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundInvestment>>>;
    public getInvestmentsForFundReport(fundId: number, fundReportId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundInvestment>>>;
    public getInvestmentsForFundReport(fundId: number, fundReportId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getInvestmentsForFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getInvestmentsForFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments`;
        return this.httpClient.request<Array<FundInvestment>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of partnership investments for the fund
     * Gets all partnership investments for the fund
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation if it exists
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPartnershipInvestments(fundId: number, fundReportId: number, fundValuationId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PartnershipInvestment>;
    public getPartnershipInvestments(fundId: number, fundReportId: number, fundValuationId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PartnershipInvestment>>;
    public getPartnershipInvestments(fundId: number, fundReportId: number, fundValuationId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PartnershipInvestment>>;
    public getPartnershipInvestments(fundId: number, fundReportId: number, fundValuationId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getPartnershipInvestments.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getPartnershipInvestments.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundValuationId !== undefined && fundValuationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundValuationId, 'fundValuationId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/partnershipInvestments`;
        return this.httpClient.request<PartnershipInvestment>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Most-recent prior forecast nTVPI per scenario
     * The fund\&#39;s most recent prior valuation finalFundNTvpi for LOW/BASE/HIGH, used as the read-only reference column when goal-seeking NAV multiples. Empty when there is no prior valuation.
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReferenceNTvpi(fundId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ReferenceNTvpi>;
    public getReferenceNTvpi(fundId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ReferenceNTvpi>>;
    public getReferenceNTvpi(fundId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ReferenceNTvpi>>;
    public getReferenceNTvpi(fundId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getReferenceNTvpi.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getReferenceNTvpi.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reference-ntvpi`;
        return this.httpClient.request<ReferenceNTvpi>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of fund reports
     * Gets all fund reports that belong to a fund
     * @param fundId The id of the fund
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportsForFund(fundId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundReportCompact>>;
    public getReportsForFund(fundId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundReportCompact>>>;
    public getReportsForFund(fundId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundReportCompact>>>;
    public getReportsForFund(fundId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getReportsForFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports`;
        return this.httpClient.request<Array<FundReportCompact>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of funds valuation scenarios
     * Gets all scenarios that belong to an fund valuation
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScenariosForFundValuation(fundId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundValuationScenario>>;
    public getScenariosForFundValuation(fundId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundValuationScenario>>>;
    public getScenariosForFundValuation(fundId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundValuationScenario>>>;
    public getScenariosForFundValuation(fundId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getScenariosForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getScenariosForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario`;
        return this.httpClient.request<Array<FundValuationScenario>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get details of a fund valuation sensitivity
     * Get details of a fund valuation sensitivity
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationSensitivityId The id of the fund valuation sensitivity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSensitivityDetailsForFundValuation(fundId: number, fundValuationId: number, fundValuationSensitivityId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationSensitivity>;
    public getSensitivityDetailsForFundValuation(fundId: number, fundValuationId: number, fundValuationSensitivityId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationSensitivity>>;
    public getSensitivityDetailsForFundValuation(fundId: number, fundValuationId: number, fundValuationSensitivityId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationSensitivity>>;
    public getSensitivityDetailsForFundValuation(fundId: number, fundValuationId: number, fundValuationSensitivityId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getSensitivityDetailsForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getSensitivityDetailsForFundValuation.');
        }
        if (fundValuationSensitivityId === null || fundValuationSensitivityId === undefined) {
            throw new Error('Required parameter fundValuationSensitivityId was null or undefined when calling getSensitivityDetailsForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/sensitivities/${this.configuration.encodeParam({name: "fundValuationSensitivityId", value: fundValuationSensitivityId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundValuationSensitivity>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of fund valuation sensitivities
     * Gets all sensitivities that belong to an fund valuation
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSensitivityForFundValuation(fundId: number, fundValuationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationSensitivityOverview>;
    public getSensitivityForFundValuation(fundId: number, fundValuationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationSensitivityOverview>>;
    public getSensitivityForFundValuation(fundId: number, fundValuationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationSensitivityOverview>>;
    public getSensitivityForFundValuation(fundId: number, fundValuationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getSensitivityForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling getSensitivityForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/sensitivities`;
        return this.httpClient.request<FundValuationSensitivityOverview>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of fund valuations
     * Retrieves all valuations associated with the specified fund. This endpoint is intended for internal management purposes on deal level, such as creating seller positions. If you are accessing valuations as part of a fund report, use the endpoint &#x60;/api/funds/{fundId}/reports/{fundReportId}/valuations&#x60; instead.
     * @param fundId The id of the fund
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getValuationsForFund(fundId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundValuation>>;
    public getValuationsForFund(fundId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundValuation>>>;
    public getValuationsForFund(fundId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundValuation>>>;
    public getValuationsForFund(fundId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getValuationsForFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations`;
        return this.httpClient.request<Array<FundValuation>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of fund valuations
     * Gets all fund valuations that belong to a fund report
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getValuationsForFundReport(fundId: number, fundReportId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundValuation>>;
    public getValuationsForFundReport(fundId: number, fundReportId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundValuation>>>;
    public getValuationsForFundReport(fundId: number, fundReportId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundValuation>>>;
    public getValuationsForFundReport(fundId: number, fundReportId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling getValuationsForFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling getValuationsForFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations`;
        return this.httpClient.request<Array<FundValuation>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Goal seek - compute, save and return updated valuation
     * Computes the bid price adjustment to achieve the specified target(s), saves the goal seek settings and bid price adjustment, and returns the full updated valuation with scenarios.
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param goalSeekRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public goalSeek(fundId: number, fundValuationId: number, goalSeekRequest: GoalSeekRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public goalSeek(fundId: number, fundValuationId: number, goalSeekRequest: GoalSeekRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public goalSeek(fundId: number, fundValuationId: number, goalSeekRequest: GoalSeekRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public goalSeek(fundId: number, fundValuationId: number, goalSeekRequest: GoalSeekRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling goalSeek.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling goalSeek.');
        }
        if (goalSeekRequest === null || goalSeekRequest === undefined) {
            throw new Error('Required parameter goalSeekRequest was null or undefined when calling goalSeek.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/goalSeek`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: goalSeekRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Goal-seek NAV multiples to target nTVPIs
     * Solves each LOW/BASE/HIGH scenario NAV multiple so its finalFundNTvpi matches the supplied target, persists the multiples and regenerates the top-down forecast. Returns the updated scenarios.
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param scenarioNTvpi 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public goalSeekNavMultiplesToTargets(fundId: number, fundReportId: number, fundValuationId: number, scenarioNTvpi: ScenarioNTvpi, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundValuationScenario>>;
    public goalSeekNavMultiplesToTargets(fundId: number, fundReportId: number, fundValuationId: number, scenarioNTvpi: ScenarioNTvpi, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundValuationScenario>>>;
    public goalSeekNavMultiplesToTargets(fundId: number, fundReportId: number, fundValuationId: number, scenarioNTvpi: ScenarioNTvpi, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundValuationScenario>>>;
    public goalSeekNavMultiplesToTargets(fundId: number, fundReportId: number, fundValuationId: number, scenarioNTvpi: ScenarioNTvpi, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling goalSeekNavMultiplesToTargets.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling goalSeekNavMultiplesToTargets.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling goalSeekNavMultiplesToTargets.');
        }
        if (scenarioNTvpi === null || scenarioNTvpi === undefined) {
            throw new Error('Required parameter scenarioNTvpi was null or undefined when calling goalSeekNavMultiplesToTargets.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/nav-multiple-goal-seek`;
        return this.httpClient.request<Array<FundValuationScenario>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: scenarioNTvpi,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Partial fund update
     * partially updates and returns the fund. Should only be used to update fields that have no effect on other objects
     * @param fundId The id of the fund
     * @param patchFundRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchFund(fundId: number, patchFundRequest: PatchFundRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Fund>;
    public patchFund(fundId: number, patchFundRequest: PatchFundRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Fund>>;
    public patchFund(fundId: number, patchFundRequest: PatchFundRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Fund>>;
    public patchFund(fundId: number, patchFundRequest: PatchFundRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling patchFund.');
        }
        if (patchFundRequest === null || patchFundRequest === undefined) {
            throw new Error('Required parameter patchFundRequest was null or undefined when calling patchFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<Fund>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchFundRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Partial general partner update
     * partially updates and returns the general partner. Should only be used to update fields that have no effect on other objects
     * @param partnerId The id of the general partner
     * @param patchGeneralPartnerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchGeneralPartner(partnerId: number, patchGeneralPartnerRequest: PatchGeneralPartnerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GeneralPartner>;
    public patchGeneralPartner(partnerId: number, patchGeneralPartnerRequest: PatchGeneralPartnerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GeneralPartner>>;
    public patchGeneralPartner(partnerId: number, patchGeneralPartnerRequest: PatchGeneralPartnerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GeneralPartner>>;
    public patchGeneralPartner(partnerId: number, patchGeneralPartnerRequest: PatchGeneralPartnerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling patchGeneralPartner.');
        }
        if (patchGeneralPartnerRequest === null || patchGeneralPartnerRequest === undefined) {
            throw new Error('Required parameter patchGeneralPartnerRequest was null or undefined when calling patchGeneralPartner.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/${this.configuration.encodeParam({name: "partnerId", value: partnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<GeneralPartner>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchGeneralPartnerRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Preview return summary without saving
     * Previews the return summary by recalculating based on an edited bid price adjustment or discount to NAV, without persisting changes.
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param previewReturnSummaryRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewReturnSummary(fundId: number, fundValuationId: number, previewReturnSummaryRequest: PreviewReturnSummaryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScenarios>;
    public previewReturnSummary(fundId: number, fundValuationId: number, previewReturnSummaryRequest: PreviewReturnSummaryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScenarios>>;
    public previewReturnSummary(fundId: number, fundValuationId: number, previewReturnSummaryRequest: PreviewReturnSummaryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScenarios>>;
    public previewReturnSummary(fundId: number, fundValuationId: number, previewReturnSummaryRequest: PreviewReturnSummaryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling previewReturnSummary.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling previewReturnSummary.');
        }
        if (previewReturnSummaryRequest === null || previewReturnSummaryRequest === undefined) {
            throw new Error('Required parameter previewReturnSummaryRequest was null or undefined when calling previewReturnSummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/calc/previewReturnSummary`;
        return this.httpClient.request<FundValuationWithScenarios>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: previewReturnSummaryRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * One-time recalculation of calculatedUndrawn for fund reports never calculated (US-1099)
     * Recalculates and persists calculatedUndrawn (and the derived totalUndrawn) for every fund report still marked source&#x3D;\&#39;initial\&#39; (i.e. created before the US-1099 migration and not yet recalculated). Idempotent: each report is touched once, after which its source becomes \&#39;calculated\&#39;.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recalculateUndrawn(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RecalculateUndrawnResult>;
    public recalculateUndrawn(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RecalculateUndrawnResult>>;
    public recalculateUndrawn(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RecalculateUndrawnResult>>;
    public recalculateUndrawn(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/maintenance/recalculate-undrawn`;
        return this.httpClient.request<RecalculateUndrawnResult>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search fund valuations overview with server-side pagination, sorting, and filtering
     * Searches fund valuations with pagination, sorting, and optional free-text search across description, fund name, and deal names.
     * @param search Free-text search across description and fund name (case-insensitive).
     * @param page Zero-based page index.
     * @param size Page size (max 100).
     * @param sort Sort in format \&#39;field,direction\&#39; (e.g. \&#39;fundName,asc\&#39;). Supported fields: fundName, description, reportDate, closingDate, country, currencyIso.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchFundValuationsOverview(search?: string, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationOverviewPage>;
    public searchFundValuationsOverview(search?: string, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationOverviewPage>>;
    public searchFundValuationsOverview(search?: string, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationOverviewPage>>;
    public searchFundValuationsOverview(search?: string, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/valuations/overview/search`;
        return this.httpClient.request<FundValuationOverviewPage>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search funds with server-side pagination, sorting, and filtering
     * Searches funds with pagination, sorting, and optional free-text search across fund name.
     * @param selectedDataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param search Free-text search across fund name (case-insensitive).
     * @param page Zero-based page index.
     * @param size Page size (max 100).
     * @param sort Sort in format \&#39;field,direction\&#39; (e.g. \&#39;name,asc\&#39;). Supported fields: name, country, currencyIso, size, mainFundSize, vintageYear, endYear.
     * @param isArchived Filter by archived status. If omitted, returns all funds regardless of archive state.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchFunds(selectedDataset?: string, search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundPage>;
    public searchFunds(selectedDataset?: string, search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundPage>>;
    public searchFunds(selectedDataset?: string, search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundPage>>;
    public searchFunds(selectedDataset?: string, search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (selectedDataset !== undefined && selectedDataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>selectedDataset, 'selectedDataset');
        }
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }
        if (isArchived !== undefined && isArchived !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isArchived, 'isArchived');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/search`;
        return this.httpClient.request<FundPage>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search general partners with server-side pagination, sorting, and filtering
     * Searches general partners with pagination, sorting, and optional free-text search across partner name. Supported sort fields: name, quality.
     * @param search Free-text search across general partner name (case-insensitive).
     * @param page Zero-based page index.
     * @param size Page size (max 100).
     * @param sort Sort in format \&#39;field,direction\&#39; (e.g. \&#39;name,asc\&#39;). Supported fields: name, quality.
     * @param isArchived Filter by archived status. If omitted, returns all general partners regardless of archive state.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGeneralPartners(search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GeneralPartnerPage>;
    public searchGeneralPartners(search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GeneralPartnerPage>>;
    public searchGeneralPartners(search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GeneralPartnerPage>>;
    public searchGeneralPartners(search?: string, page?: number, size?: number, sort?: string, isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }
        if (isArchived !== undefined && isArchived !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isArchived, 'isArchived');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/search`;
        return this.httpClient.request<GeneralPartnerPage>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set the merge target on the fund
     * Updates and returns the fund
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param mergeTargetId The id of the target fund
     * @param dataset Specifies a filter for the selected dataset. This filter is optional. If nothing is specified, the master dataset is selected.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setMergeTargetFund(fundId: number, fundReportId?: number, mergeTargetId?: number, dataset?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public setMergeTargetFund(fundId: number, fundReportId?: number, mergeTargetId?: number, dataset?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public setMergeTargetFund(fundId: number, fundReportId?: number, mergeTargetId?: number, dataset?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public setMergeTargetFund(fundId: number, fundReportId?: number, mergeTargetId?: number, dataset?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling setMergeTargetFund.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundReportId !== undefined && fundReportId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundReportId, 'fundReportId');
        }
        if (mergeTargetId !== undefined && mergeTargetId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mergeTargetId, 'mergeTargetId');
        }
        if (dataset !== undefined && dataset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataset, 'dataset');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/mergeTarget`;
        return this.httpClient.request<FundData>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Skips a single AI-generated result
     * Marks the result as SKIPPED. The Asset is not modified.
     * @param resultId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public skipAiSetupResult(resultId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public skipAiSetupResult(resultId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public skipAiSetupResult(resultId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public skipAiSetupResult(resultId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (resultId === null || resultId === undefined) {
            throw new Error('Required parameter resultId was null or undefined when calling skipAiSetupResult.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ai-setup-results/${this.configuration.encodeParam({name: "resultId", value: resultId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/skip`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Starts an asynchronous AI setup job for a fund\&#39;s holdings
     * Kicks off an asynchronous job that calls AI services to generate descriptive content (company description, end markets, SWOT, general info, comparable companies) for the selected fund holdings. Generated content is staged for user review and is not written to the assets until the user explicitly accepts each item. Only one job per fund may run at a time; a second attempt while a job is active fails with 409.
     * @param fundId 
     * @param aiSetupRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startAiSetup(fundId: number, aiSetupRequest: AiSetupRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<number>;
    public startAiSetup(fundId: number, aiSetupRequest: AiSetupRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<number>>;
    public startAiSetup(fundId: number, aiSetupRequest: AiSetupRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<number>>;
    public startAiSetup(fundId: number, aiSetupRequest: AiSetupRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling startAiSetup.');
        }
        if (aiSetupRequest === null || aiSetupRequest === undefined) {
            throw new Error('Required parameter aiSetupRequest was null or undefined when calling startAiSetup.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/ai-setup`;
        return this.httpClient.request<number>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: aiSetupRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates an fund
     * Updates and returns the fund
     * @param fundId The id of the fund
     * @param updateFundRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFund(fundId: number, updateFundRequest: UpdateFundRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public updateFund(fundId: number, updateFundRequest: UpdateFundRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public updateFund(fundId: number, updateFundRequest: UpdateFundRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public updateFund(fundId: number, updateFundRequest: UpdateFundRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFund.');
        }
        if (updateFundRequest === null || updateFundRequest === undefined) {
            throw new Error('Required parameter updateFundRequest was null or undefined when calling updateFund.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundData>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a fund investment
     * Updates and returns the fund investment
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param fundInvestment 
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, fundValuationId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public updateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, fundValuationId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public updateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, fundValuationId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public updateFundInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, fundInvestment: FundInvestment, fundValuationId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestment.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestment.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling updateFundInvestment.');
        }
        if (fundInvestment === null || fundInvestment === undefined) {
            throw new Error('Required parameter fundInvestment was null or undefined when calling updateFundInvestment.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundValuationId !== undefined && fundValuationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundValuationId, 'fundValuationId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundInvestment>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundInvestment,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the developments since investment commentary for a fund investment
     * Narrow update of just developmentsSinceInvestment, stamped per (asset, fund report) via this fund investment. Does not touch any other fund investment field (US-1277).
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param updateFundInvestmentDevelopmentsSinceInvestmentRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestmentDevelopmentsSinceInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentDevelopmentsSinceInvestmentRequest: UpdateFundInvestmentDevelopmentsSinceInvestmentRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public updateFundInvestmentDevelopmentsSinceInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentDevelopmentsSinceInvestmentRequest: UpdateFundInvestmentDevelopmentsSinceInvestmentRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public updateFundInvestmentDevelopmentsSinceInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentDevelopmentsSinceInvestmentRequest: UpdateFundInvestmentDevelopmentsSinceInvestmentRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public updateFundInvestmentDevelopmentsSinceInvestment(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentDevelopmentsSinceInvestmentRequest: UpdateFundInvestmentDevelopmentsSinceInvestmentRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestmentDevelopmentsSinceInvestment.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestmentDevelopmentsSinceInvestment.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling updateFundInvestmentDevelopmentsSinceInvestment.');
        }
        if (updateFundInvestmentDevelopmentsSinceInvestmentRequest === null || updateFundInvestmentDevelopmentsSinceInvestmentRequest === undefined) {
            throw new Error('Required parameter updateFundInvestmentDevelopmentsSinceInvestmentRequest was null or undefined when calling updateFundInvestmentDevelopmentsSinceInvestment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/developmentsSinceInvestment`;
        return this.httpClient.request<FundInvestment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundInvestmentDevelopmentsSinceInvestmentRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Partially updates dates/realization of a fund investment
     * Updates only investmentDate, exitDate, and isRealized, then returns the fund investment.
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param updateFundInvestmentRealizationRequest 
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestmentRealization(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRealizationRequest: UpdateFundInvestmentRealizationRequest, fundValuationId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public updateFundInvestmentRealization(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRealizationRequest: UpdateFundInvestmentRealizationRequest, fundValuationId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public updateFundInvestmentRealization(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRealizationRequest: UpdateFundInvestmentRealizationRequest, fundValuationId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public updateFundInvestmentRealization(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRealizationRequest: UpdateFundInvestmentRealizationRequest, fundValuationId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestmentRealization.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestmentRealization.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling updateFundInvestmentRealization.');
        }
        if (updateFundInvestmentRealizationRequest === null || updateFundInvestmentRealizationRequest === undefined) {
            throw new Error('Required parameter updateFundInvestmentRealizationRequest was null or undefined when calling updateFundInvestmentRealization.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundValuationId !== undefined && fundValuationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundValuationId, 'fundValuationId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundInvestment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundInvestmentRealizationRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the recent financial performance commentary for a fund investment
     * Narrow update of just recentFinancialPerformance, stamped per (asset, fund report) via this fund investment. Does not touch any other fund investment field (US-1277).
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param updateFundInvestmentRecentFinancialPerformanceRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestmentRecentFinancialPerformance(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRecentFinancialPerformanceRequest: UpdateFundInvestmentRecentFinancialPerformanceRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public updateFundInvestmentRecentFinancialPerformance(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRecentFinancialPerformanceRequest: UpdateFundInvestmentRecentFinancialPerformanceRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public updateFundInvestmentRecentFinancialPerformance(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRecentFinancialPerformanceRequest: UpdateFundInvestmentRecentFinancialPerformanceRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public updateFundInvestmentRecentFinancialPerformance(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentRecentFinancialPerformanceRequest: UpdateFundInvestmentRecentFinancialPerformanceRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestmentRecentFinancialPerformance.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestmentRecentFinancialPerformance.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling updateFundInvestmentRecentFinancialPerformance.');
        }
        if (updateFundInvestmentRecentFinancialPerformanceRequest === null || updateFundInvestmentRecentFinancialPerformanceRequest === undefined) {
            throw new Error('Required parameter updateFundInvestmentRecentFinancialPerformanceRequest was null or undefined when calling updateFundInvestmentRecentFinancialPerformance.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/recentFinancialPerformance`;
        return this.httpClient.request<FundInvestment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundInvestmentRecentFinancialPerformanceRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the transaction summary for a fund investment
     * Narrow update of just transactionSummary, stamped per (asset, fund report) via this fund investment. Does not touch any other fund investment field — replaces the earlier full-object PUT, which sent a whole stale snapshot plus a possibly stale fundValuationId and triggered a second fund-report recalculation (US-1277).
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestmentId The id of the fund investment
     * @param updateFundInvestmentTransactionSummaryRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestmentTransactionSummary(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentTransactionSummaryRequest: UpdateFundInvestmentTransactionSummaryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundInvestment>;
    public updateFundInvestmentTransactionSummary(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentTransactionSummaryRequest: UpdateFundInvestmentTransactionSummaryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundInvestment>>;
    public updateFundInvestmentTransactionSummary(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentTransactionSummaryRequest: UpdateFundInvestmentTransactionSummaryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundInvestment>>;
    public updateFundInvestmentTransactionSummary(fundId: number, fundReportId: number, fundInvestmentId: number, updateFundInvestmentTransactionSummaryRequest: UpdateFundInvestmentTransactionSummaryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestmentTransactionSummary.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestmentTransactionSummary.');
        }
        if (fundInvestmentId === null || fundInvestmentId === undefined) {
            throw new Error('Required parameter fundInvestmentId was null or undefined when calling updateFundInvestmentTransactionSummary.');
        }
        if (updateFundInvestmentTransactionSummaryRequest === null || updateFundInvestmentTransactionSummaryRequest === undefined) {
            throw new Error('Required parameter updateFundInvestmentTransactionSummaryRequest was null or undefined when calling updateFundInvestmentTransactionSummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments/${this.configuration.encodeParam({name: "fundInvestmentId", value: fundInvestmentId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/transactionSummary`;
        return this.httpClient.request<FundInvestment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundInvestmentTransactionSummaryRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates fund investments
     * Updates and returns a list of fund investments
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundInvestment 
     * @param fundValuationId The id of the fund valuation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundInvestments(fundId: number, fundReportId: number, fundInvestment: Array<FundInvestment>, fundValuationId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundInvestment>>;
    public updateFundInvestments(fundId: number, fundReportId: number, fundInvestment: Array<FundInvestment>, fundValuationId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundInvestment>>>;
    public updateFundInvestments(fundId: number, fundReportId: number, fundInvestment: Array<FundInvestment>, fundValuationId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundInvestment>>>;
    public updateFundInvestments(fundId: number, fundReportId: number, fundInvestment: Array<FundInvestment>, fundValuationId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundInvestments.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundInvestments.');
        }
        if (fundInvestment === null || fundInvestment === undefined) {
            throw new Error('Required parameter fundInvestment was null or undefined when calling updateFundInvestments.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (fundValuationId !== undefined && fundValuationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fundValuationId, 'fundValuationId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/investments`;
        return this.httpClient.request<Array<FundInvestment>>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundInvestment,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a fund report
     * Updates and returns the fund report
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param updateFundReportRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundReport(fundId: number, fundReportId: number, updateFundReportRequest: UpdateFundReportRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public updateFundReport(fundId: number, fundReportId: number, updateFundReportRequest: UpdateFundReportRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public updateFundReport(fundId: number, fundReportId: number, updateFundReportRequest: UpdateFundReportRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public updateFundReport(fundId: number, fundReportId: number, updateFundReportRequest: UpdateFundReportRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundReport.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundReport.');
        }
        if (updateFundReportRequest === null || updateFundReportRequest === undefined) {
            throw new Error('Required parameter updateFundReportRequest was null or undefined when calling updateFundReport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundData>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundReportRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a fund valuation
     * Updates and returns the fund valuation
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param updateFundValuationRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundValuation(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationRequest: UpdateFundValuationRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public updateFundValuation(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationRequest: UpdateFundValuationRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public updateFundValuation(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationRequest: UpdateFundValuationRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public updateFundValuation(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationRequest: UpdateFundValuationRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundValuation.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateFundValuation.');
        }
        if (updateFundValuationRequest === null || updateFundValuationRequest === undefined) {
            throw new Error('Required parameter updateFundValuationRequest was null or undefined when calling updateFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundData>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundValuationRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the fund valuation description
     * Updates and returns only the description of the specified fund valuation. Other fields are unchanged.
     * @param fundValuationId The id of the fund valuation
     * @param updateFundValuationDescriptionRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundValuationDescription(fundValuationId: number, updateFundValuationDescriptionRequest: UpdateFundValuationDescriptionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<TraceableText>;
    public updateFundValuationDescription(fundValuationId: number, updateFundValuationDescriptionRequest: UpdateFundValuationDescriptionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<TraceableText>>;
    public updateFundValuationDescription(fundValuationId: number, updateFundValuationDescriptionRequest: UpdateFundValuationDescriptionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<TraceableText>>;
    public updateFundValuationDescription(fundValuationId: number, updateFundValuationDescriptionRequest: UpdateFundValuationDescriptionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateFundValuationDescription.');
        }
        if (updateFundValuationDescriptionRequest === null || updateFundValuationDescriptionRequest === undefined) {
            throw new Error('Required parameter updateFundValuationDescriptionRequest was null or undefined when calling updateFundValuationDescription.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/description`;
        return this.httpClient.request<TraceableText>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundValuationDescriptionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the fund valuation management fee scale and recalculates scenarios
     * Updates the fund valuation management fee scale and recalculates scenarios. Sends back valuation, scenarios and aggregated cashflows.
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param updateFundValuationManagementFeeScaleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundValuationManagementFeeScale(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationManagementFeeScaleRequest: UpdateFundValuationManagementFeeScaleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationWithScnsAndAggrCFs>;
    public updateFundValuationManagementFeeScale(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationManagementFeeScaleRequest: UpdateFundValuationManagementFeeScaleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationWithScnsAndAggrCFs>>;
    public updateFundValuationManagementFeeScale(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationManagementFeeScaleRequest: UpdateFundValuationManagementFeeScaleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationWithScnsAndAggrCFs>>;
    public updateFundValuationManagementFeeScale(fundId: number, fundReportId: number, fundValuationId: number, updateFundValuationManagementFeeScaleRequest: UpdateFundValuationManagementFeeScaleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundValuationManagementFeeScale.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundValuationManagementFeeScale.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateFundValuationManagementFeeScale.');
        }
        if (updateFundValuationManagementFeeScaleRequest === null || updateFundValuationManagementFeeScaleRequest === undefined) {
            throw new Error('Required parameter updateFundValuationManagementFeeScaleRequest was null or undefined when calling updateFundValuationManagementFeeScale.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/managementfeescale`;
        return this.httpClient.request<FundValuationWithScnsAndAggrCFs>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFundValuationManagementFeeScaleRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a scenario
     * Updates and returns the scenario
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param scenarioId The id of the scenario
     * @param fundValuationScenario 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, fundValuationScenario: FundValuationScenario, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationScenario>;
    public updateFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, fundValuationScenario: FundValuationScenario, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationScenario>>;
    public updateFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, fundValuationScenario: FundValuationScenario, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationScenario>>;
    public updateFundValuationScenario(fundId: number, fundValuationId: number, scenarioId: number, fundValuationScenario: FundValuationScenario, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundValuationScenario.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateFundValuationScenario.');
        }
        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling updateFundValuationScenario.');
        }
        if (fundValuationScenario === null || fundValuationScenario === undefined) {
            throw new Error('Required parameter fundValuationScenario was null or undefined when calling updateFundValuationScenario.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario/${this.configuration.encodeParam({name: "scenarioId", value: scenarioId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<FundValuationScenario>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationScenario,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates forecast Net Current Assets (NCA) for the fund valuation
     * Updates the net current asset fields (low/base/high) on the three fund valuation scenarios for the specified valuation and returns the updated fund data. !!! Temporary fix, see #24375
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param forecastNetCurrentAssetRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFundValuationScenariosNca(fundId: number, fundReportId: number, fundValuationId: number, forecastNetCurrentAssetRequest: ForecastNetCurrentAssetRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundData>;
    public updateFundValuationScenariosNca(fundId: number, fundReportId: number, fundValuationId: number, forecastNetCurrentAssetRequest: ForecastNetCurrentAssetRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundData>>;
    public updateFundValuationScenariosNca(fundId: number, fundReportId: number, fundValuationId: number, forecastNetCurrentAssetRequest: ForecastNetCurrentAssetRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundData>>;
    public updateFundValuationScenariosNca(fundId: number, fundReportId: number, fundValuationId: number, forecastNetCurrentAssetRequest: ForecastNetCurrentAssetRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateFundValuationScenariosNca.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updateFundValuationScenariosNca.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateFundValuationScenariosNca.');
        }
        if (forecastNetCurrentAssetRequest === null || forecastNetCurrentAssetRequest === undefined) {
            throw new Error('Required parameter forecastNetCurrentAssetRequest was null or undefined when calling updateFundValuationScenariosNca.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/nca`;
        return this.httpClient.request<FundData>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: forecastNetCurrentAssetRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a general partner
     * Updates and returns the general partner
     * @param partnerId The id of the general partner
     * @param generalPartner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateGeneralPartner(partnerId: number, generalPartner: GeneralPartner, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GeneralPartner>;
    public updateGeneralPartner(partnerId: number, generalPartner: GeneralPartner, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GeneralPartner>>;
    public updateGeneralPartner(partnerId: number, generalPartner: GeneralPartner, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GeneralPartner>>;
    public updateGeneralPartner(partnerId: number, generalPartner: GeneralPartner, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling updateGeneralPartner.');
        }
        if (generalPartner === null || generalPartner === undefined) {
            throw new Error('Required parameter generalPartner was null or undefined when calling updateGeneralPartner.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/partners/${this.configuration.encodeParam({name: "partnerId", value: partnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<GeneralPartner>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: generalPartner,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a pattern and recalculate cashflows for a fund valuation
     * Updates the pattern values and recalculates cashflows for the fund valuation atomically. Returns the updated pattern and recalculated fund valuation data.
     * @param fundId The id of the fund
     * @param fundReportId The id of the fund report
     * @param fundValuationId The id of the fund valuation
     * @param patternId The id of the pattern to update
     * @param cashflowPattern 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePatternForFundValuation(fundId: number, fundReportId: number, fundValuationId: number, patternId: number, cashflowPattern: CashflowPattern, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<CashflowPatternUpdateResult>;
    public updatePatternForFundValuation(fundId: number, fundReportId: number, fundValuationId: number, patternId: number, cashflowPattern: CashflowPattern, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<CashflowPatternUpdateResult>>;
    public updatePatternForFundValuation(fundId: number, fundReportId: number, fundValuationId: number, patternId: number, cashflowPattern: CashflowPattern, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<CashflowPatternUpdateResult>>;
    public updatePatternForFundValuation(fundId: number, fundReportId: number, fundValuationId: number, patternId: number, cashflowPattern: CashflowPattern, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updatePatternForFundValuation.');
        }
        if (fundReportId === null || fundReportId === undefined) {
            throw new Error('Required parameter fundReportId was null or undefined when calling updatePatternForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updatePatternForFundValuation.');
        }
        if (patternId === null || patternId === undefined) {
            throw new Error('Required parameter patternId was null or undefined when calling updatePatternForFundValuation.');
        }
        if (cashflowPattern === null || cashflowPattern === undefined) {
            throw new Error('Required parameter cashflowPattern was null or undefined when calling updatePatternForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/reports/${this.configuration.encodeParam({name: "fundReportId", value: fundReportId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/patterns/${this.configuration.encodeParam({name: "patternId", value: patternId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<CashflowPatternUpdateResult>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: cashflowPattern,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the scenario array
     * Updates and returns the scenario array
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationScenario 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateScenariosForFundValuation(fundId: number, fundValuationId: number, fundValuationScenario: Array<FundValuationScenario>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<FundValuationScenario>>;
    public updateScenariosForFundValuation(fundId: number, fundValuationId: number, fundValuationScenario: Array<FundValuationScenario>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<FundValuationScenario>>>;
    public updateScenariosForFundValuation(fundId: number, fundValuationId: number, fundValuationScenario: Array<FundValuationScenario>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<FundValuationScenario>>>;
    public updateScenariosForFundValuation(fundId: number, fundValuationId: number, fundValuationScenario: Array<FundValuationScenario>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling updateScenariosForFundValuation.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling updateScenariosForFundValuation.');
        }
        if (fundValuationScenario === null || fundValuationScenario === undefined) {
            throw new Error('Required parameter fundValuationScenario was null or undefined when calling updateScenariosForFundValuation.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/scenario`;
        return this.httpClient.request<Array<FundValuationScenario>>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationScenario,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updates fund valuation deferrals
     * Creates or updates fund valuation deferrals
     * @param fundId The id of the fund
     * @param fundValuationId The id of the fund valuation
     * @param fundValuationDeferralData 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertFundValuationDeferrals(fundId: number, fundValuationId: number, fundValuationDeferralData: FundValuationDeferralData, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FundValuationDeferralData>;
    public upsertFundValuationDeferrals(fundId: number, fundValuationId: number, fundValuationDeferralData: FundValuationDeferralData, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FundValuationDeferralData>>;
    public upsertFundValuationDeferrals(fundId: number, fundValuationId: number, fundValuationDeferralData: FundValuationDeferralData, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FundValuationDeferralData>>;
    public upsertFundValuationDeferrals(fundId: number, fundValuationId: number, fundValuationDeferralData: FundValuationDeferralData, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (fundId === null || fundId === undefined) {
            throw new Error('Required parameter fundId was null or undefined when calling upsertFundValuationDeferrals.');
        }
        if (fundValuationId === null || fundValuationId === undefined) {
            throw new Error('Required parameter fundValuationId was null or undefined when calling upsertFundValuationDeferrals.');
        }
        if (fundValuationDeferralData === null || fundValuationDeferralData === undefined) {
            throw new Error('Required parameter fundValuationDeferralData was null or undefined when calling upsertFundValuationDeferrals.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/funds/${this.configuration.encodeParam({name: "fundId", value: fundId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/valuations/${this.configuration.encodeParam({name: "fundValuationId", value: fundValuationId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/deferrals`;
        return this.httpClient.request<FundValuationDeferralData>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: fundValuationDeferralData,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
